/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Select, Form } from 'antd';

const { Option } = Select;

const RefundUpdateForm = ({
  form, handleStatusChange, kitegatewayReference,
}) => {
  const transactionStatuses = ['COMPLETED', 'CANCELLED', 'FAILED'].map((tStatus) => (
    <Option key={tStatus} value={tStatus}>
      {tStatus}
    </Option>
  ));

  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={form}
    >
      <div>New Status</div>
      <Form.Item>
        <Select
          allowClear
          showArrow
          shouldUpdate
          style={{ width: '100%' }}
          placeholder="Please select status"
          onChange={(e) => handleStatusChange(e)}
        >
          {transactionStatuses}
        </Select>
      </Form.Item>

      <div>ARN (Refund ID)</div>
      <Form.Item
        name="refund_id"
      >
        <Input placeholder="Usually from the final acquirer" />
      </Form.Item>

      <div>Processor Reference/Id</div>
      <Form.Item
        name="processor_reference"
      >
        <Input placeholder="e.g Transaction ID on the PSP side" />
      </Form.Item>

      <Form.Item
        name="kitegateway_reference"
        initialValue={kitegatewayReference}
      >
        <Input readOnly />
      </Form.Item>
    </Form>
  );
};

RefundUpdateForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  handleStatusChange: PropTypes.func.isRequired,
  kitegatewayReference: PropTypes.string.isRequired,
};

RefundUpdateForm.defaultProps = {
  form: {},
};

export default RefundUpdateForm;
